import { Box, Stack, TextField, Typography } from '@mui/material';
import React from 'react';

type FormFieldLongProps = {
  label: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  rows?: number;
  width?: number | string;
  caracterLength?: number;
};

export default function FormFieldLong({
  label,
  value,
  onChange,
  disabled = false,
  rows = 4,
  width = '100%',
  caracterLength = 1000,
}: FormFieldLongProps) {
  return (
    <Box sx={{ mt: 2, width }}>
      <Typography variant="fieldHeader">{label}</Typography>
      <Stack direction="row" spacing={2} sx={{ width: width || '100%' }}>
        <TextField
          sx={{
            flexGrow: 1,
            '& .MuiOutlinedInput-root': {
              borderRadius: 2,
            },
          }}
          size="small"
          multiline
          rows={rows}
          value={value}
          onChange={onChange}
          disabled={disabled}
          inputProps={{ maxLength: caracterLength }}
          helperText={`${value.length}/${caracterLength}`}
          error={value.length >= caracterLength}
          fullWidth
        />
      </Stack>
    </Box>
  );
}
